import AppRecord from './AppRecord.js'

class CurrencyRate extends AppRecord {
  getRate(cur, base='DKK'){
    return parseFloat(this[cur]) / parseFloat(this[base])
  }
  get GBp(){
    return parseFloat(this['GBP']) / 100
  }
  set GBp(v){
    this._GBp = v
  }
  get USc(){
    return parseFloat(this['USD']) / 100
  }
  set USc(v){
    this._USc = v
  }
  get ZAc(){
    return parseFloat(this['ZAR']) / 100
  }
  set ZAc(v){
    this._ZAc = v
  }
}
export default CurrencyRate
